/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react';

import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGrid = ({ actionLabel, persons, onSelected }) => (
  <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
    <thead>
      <tr>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Birth Date</th>
        <th>Organization</th>
        <th>Effective Date</th>
        <th>Expiration Date</th>
        <th>{actionLabel}</th>
      </tr>
    </thead>
    <tbody>
      {persons.map((p, i) => (
        <tr key={i}>
          <td>{p.firstName}</td>
          <td>{p.lastName}</td>
          <td>{formatDate(p.birthDate)}</td>
          <td>{p.orgDuration?.orgUnitName || ''}</td>
          <td>{p.orgDuration?.effectiveDate ? formatDate(p.orgDuration.effectiveDate) : ''}</td>
          <td>{p.orgDuration?.expirationDate ? formatDate(p.orgDuration.expirationDate) : ''}</td>
          <td>
            <Checkbox
              label=""
              name="isSelected"
              onChange={() => onSelected(p.personId)}
              checked={p.isSelected} />
          </td>
        </tr>
      ))}
    </tbody>
  </table >
);

const SmallGrid = ({ persons, onSelected }) => (
  <div className={[global.SmallTable, 'hidden-lg hidden-md'].join(' ')}>
    {persons.map((p, i) => (
      <div className={global.SmallTableRow} key={i}>
        <div className={['row', global.SmallTableRowHead].join(' ')}>
          <span className="hidden-xs">{p.firstName} {p.lastName}</span>&nbsp;
          <div className={global.IconButton}>
            <Checkbox
              label=""
              name="isSelected"
              onChange={() => onSelected(p.personId)}
              checked={p.isSelected} />
          </div>
        </div>
        <div className={['row', global.SmallTableRowInfo].join(' ')}>
          <div className={['col-xs-6 col-sm-3 visible-xs', global.SmallTableRowLabels].join(' ')}>Name</div>
          <div className={['col-xs-6 col-sm-3 visible-xs', global.SmallTableRowData].join(' ')}>{p.firstName} {p.lastName}</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Birth Date</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{formatDate(p.birthDate)}</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Organization</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{p.orgDuration?.orgUnitName || <span>&nbsp;</span>}</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Effective Date</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{p.orgDuration?.effectiveDate ? formatDate(p.orgDuration.effectiveDate) : <span>&nbsp;</span>}</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Expiration Date</div>
          <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{p.orgDuration?.expirationDate ? formatDate(p.orgDuration.expirationDate) : <span>&nbsp;</span>}</div>
        </div>
      </div>
    ))}
  </div>
);

const PreCompLocationStaffDupGrid = ({ actionLabel, persons, onSelected }) => (
  <Fragment>
    <LargeGrid actionLabel={actionLabel} persons={persons} onSelected={onSelected} />
    <SmallGrid actionLabel={actionLabel} persons={persons} onSelected={onSelected} />
  </Fragment>
);

export default PreCompLocationStaffDupGrid;